/*
 * Public API Surface of hx-order
 */

import { TranslocoService } from '@jsverse/transloco';
// @ts-ignore
import * as ru from './lib/i18n/ru.json';
// @ts-ignore
import * as en from './lib/i18n/en.json';
// @ts-ignore
import * as kk from './lib/i18n/kk.json';

export * from './lib/order-edit/order-edit.component';
export * from './lib/order-new/order-new.component';
export * from './lib/order-icon/order-icon.component';
export * from './lib/promo-code/promo-code.component';
export * from './lib/order-invoice-doc/order-invoice-doc.component';
export * from './lib/managers-info/managers-info.component';
export * from './lib/order-info/order-info.component';
export * from './lib/feedback-list/hx-feedback-list.component';
export * from './lib/hx-order.routing';

export function addOrderI18n(tr: TranslocoService) {
  tr.setTranslation(ru, 'ru', {merge: true});
  tr.setTranslation(kk, 'kk', {merge: true});
  tr.setTranslation(en, 'en', {merge: true});
}
